import { RadioGroup as MuiRadioGroup } from "@mui/material";
import { styled } from "@mui/material/styles";

export const RadioGroup = styled(MuiRadioGroup)({
  minWidth: "238px",
  padding: "10px 20px",

  "& > .MuiGrid-root": {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",

    "& > .react-datepicker-wrapper": {
      width: "auto",
    },
  },
});
